<template lang="html">
  <div class="landing-wrapper">
    <button @click="enter">Activate SPLInt</button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'landing',
  data() {
    return {
      delay: 500,
    }
  },
  computed: {
    ...mapState({
      newGame: state => state.gameSettings.newGame,
    }),
  },
  methods: {
    enter() {
      this.$emit('initAudio');
      this.$router.push(this.newGame ? '/intro' : '/welcome');
    }
  },
  // mounted() {
  //   setTimeout(() => {
  //     this.$router.push(this.newGame ? '/intro' : '/welcome');
  //   }, this.delay);
  // }
}
</script>

<style lang="css" scoped>
.landing-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
